import React, { useEffect, useMemo, useState } from 'react';
import {
  SessionInvestigationDisplay, SessionReplayExports, configureSessionAccess, parseReplayLink, loadAlertSession,
} from '../shared/activity-viewer';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.monalerte.app';

/**
 * Relecture partagée par un administrateur MonAlerte (service de police…) :
 * le lien porte le sel, le mot de passe est transmis à part. Tout est
 * déchiffré dans ce navigateur ; le serveur ne voit ni le mot de passe ni la clé.
 */
export default function PoliceReplayPage() {
  const link = useMemo(() => parseReplayLink(window.location.href), []);
  const [password, setPassword] = useState('');
  const [state, setState] = useState({ loading: false, error: '', loaded: null });

  useEffect(() => () => configureSessionAccess(null), []);

  const open = async event => {
    event.preventDefault();
    setState({ loading: true, error: '', loaded: null });
    try {
      const access = { version: 2, password: password.trim(), salt: link.salt, iterations: link.iterations };
      const loaded = await loadAlertSession({ apiUrl: API_URL, sessionId: link.sessionId, access });
      configureSessionAccess({
        version: 2,
        token: loaded.headers['X-Activity-Access'],
        keys: { events: loaded.eventsKey, mediaHls: loaded.mediaKey },
      });
      setPassword('');
      setState({ loading: false, error: '', loaded });
    } catch (error) {
      setState({ loading: false, error: /refusé|403|401/.test(error.message) ? 'Mot de passe incorrect, ou lien expiré ou révoqué.' : (error.message || 'Ouverture impossible.'), loaded: null });
    }
  };

  if (!link) {
    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0A192F', color: '#E0E0E0' }}>
        <p>Lien de relecture incomplet : utilisez le lien exact transmis par MonAlerte.</p>
      </main>
    );
  }

  if (state.loaded) {
    const headers = state.loaded.headers;
    const sessionPath = `${API_URL}/api/session/${encodeURIComponent(link.sessionId)}`;
    return (
      <SessionInvestigationDisplay
        sessionId={link.sessionId}
        apiUrl={API_URL}
        header={<strong>Relecture MonAlerte</strong>}
        toolbar={(
          <SessionReplayExports
            loaded={state.loaded}
            source={sessionPath}
            registry={{ url: `${sessionPath}/evidence/police`, headers }}
            exportLog={{ url: `${sessionPath}/evidence/police/exports`, headers }}
            exportedFrom="Lien de relecture MonAlerte protégé par mot de passe"
          />
        )}
      />
    );
  }

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0A192F', color: '#E0E0E0' }}>
      <form onSubmit={open} style={{ width: '100%', maxWidth: 460, background: '#112240', borderRadius: 16, padding: 28, display: 'grid', gap: 14 }}>
        <h1 style={{ margin: 0, fontSize: '1.4rem' }}>Relecture d’une session MonAlerte</h1>
        <p style={{ margin: 0, color: '#A0A0A0', fontSize: '0.95rem' }}>
          Saisissez le mot de passe transmis séparément. La session est déchiffrée dans ce navigateur uniquement ;
          chaque export du dossier de preuve est enregistré.
        </p>
        <input type="password" value={password} onChange={event => setPassword(event.target.value)} autoFocus
          autoComplete="off" spellCheck={false} placeholder="Mot de passe"
          style={{ padding: 12, borderRadius: 10, border: '1px solid #334155', background: '#0A192F', color: '#fff', fontSize: '1rem', letterSpacing: '0.05em' }} />
        <button type="submit" disabled={state.loading || !password.trim()}
          style={{ padding: 12, borderRadius: 10, border: 0, background: '#FACC15', color: '#0A192F', fontWeight: 700, cursor: 'pointer' }}>
          {state.loading ? 'Vérification…' : 'Ouvrir la relecture'}
        </button>
        {state.error && <p role="alert" style={{ margin: 0, color: '#fca5a5' }}>{state.error}</p>}
      </form>
    </main>
  );
}
